"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveThemeVariable = exports.resolveRawThemeVariables = exports.constructThemeCache = exports.createCacheObject = exports.getThemeVariableGroupNames = exports.looksLikeThemeVariable = void 0;
const without_1 = __importDefault(require("lodash/without"));
const has_1 = __importDefault(require("lodash/has"));
const theme_1 = require("../themes/typings/theme");
/**
 * Checks to determine if a value is of type theme variable
 * @param value string of value
 */
const looksLikeThemeVariable = (value) => typeof value === 'string' && value.charAt(0) === '$';
exports.looksLikeThemeVariable = looksLikeThemeVariable;
/**
 * Returns a list of keys in theme which contain variables
 */
const getThemeVariableGroupNames = (theme) => {
    const topLevelKeys = Object.keys(theme);
    return (0, without_1.default)(topLevelKeys, ...theme_1.specialThemeKeys);
};
exports.getThemeVariableGroupNames = getThemeVariableGroupNames;
/**
 * Create empty object for cache
 */
const createCacheObject = () => Object.create(null);
exports.createCacheObject = createCacheObject;
/**
 * Construct Theme Cache
 */
const constructThemeCache = () => {
    return {
        [theme_1.RAW_THEME_VARIABLES]: (0, exports.createCacheObject)(),
        [theme_1.THEME_VARIABLES]: (0, exports.createCacheObject)(),
    };
};
exports.constructThemeCache = constructThemeCache;
/**
 * Returns theme variables that are either in cache or set in cache
 * @param theme - global theme
 * @param themeVariable - string of possible theme variable
 */
const resolveRawThemeVariables = (theme, themeVariable) => {
    const rawCachedValue = theme.__cache[theme_1.RAW_THEME_VARIABLES];
    if (!(0, has_1.default)(rawCachedValue, themeVariable)) {
        // Merge all the variables together, for faster/easier lookups.
        // This uses a `for` loop for speed only.
        const variableGroupsToMerge = (0, exports.getThemeVariableGroupNames)(theme);
        for (let i = 0; i < variableGroupsToMerge.length; i++) {
            const key = variableGroupsToMerge[i];
            Object.assign(rawCachedValue, theme[key]);
        }
        theme.__cache[theme_1.RAW_THEME_VARIABLES] = rawCachedValue;
    }
    return rawCachedValue[themeVariable];
};
exports.resolveRawThemeVariables = resolveRawThemeVariables;
/**
 * Each Theme object other than variants are run through a build method which checks to see
 * if the value of a variable references another variable in the theme. If so, it returns the theme variable value
 * @param theme - global theme
 * @param themeVariable - string of possible theme variable
 */
const resolveThemeVariable = (theme, themeVariable) => {
    const cachedVariableValues = theme.__cache[theme_1.THEME_VARIABLES];
    if (!(0, has_1.default)(cachedVariableValues, themeVariable)) {
        // First grab the value: it'll either be a literal value or another variable
        let value = (0, exports.resolveRawThemeVariables)(theme, themeVariable);
        if (!value) {
            throw new Error(`Invalid variable name: "${themeVariable}" was not found in the theme.`);
        }
        if ((0, exports.looksLikeThemeVariable)(value)) {
            // Recurse!
            value = (0, exports.resolveThemeVariable)(theme, value);
        }
        cachedVariableValues[themeVariable] = value;
    }
    return cachedVariableValues[themeVariable];
};
exports.resolveThemeVariable = resolveThemeVariable;
